module.exports = __webpack_public_path__ + "static/img/bg@2x.6207d90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coupon/bg@2x.png
// module id = 419
// module chunks = 1